<template>
  <div class="relative inline-block text-left">
    <div>
      <button
        id="social-button"
        type="button"
        class="inline-flex w-full justify-center gap-x-2.4 bg-white px-3 py-3 border"
        :class="{
          'border-black-light border-b-transparent': open,
          'border-transparent': !open,
        }"
        :aria-expanded="open"
        aria-haspopup="true"
        @click="toggleDropdown"
      >
        <span class="sr-only">Social Sharing button</span>
        <SvgIcon name="share" class="h-9.6 w-9.6 text-black-light" />
      </button>
    </div>

    <transition
      enter-active-class="transition duration-100 ease-out"
      enter-from-class="transform scale-95 opacity-0"
      enter-to-class="transform scale-100 opacity-100"
      leave-active-class="transition duration-75 ease-in"
      leave-from-class="transform scale-100 opacity-100"
      leave-to-class="transform scale-95 opacity-0"
    >
      <div
        class="absolute right-0 z-10 w-56 origin-top-right bg-white border border-black-light"
        :class="{
          block: open,
          hidden: !open,
        }"
        role="menu"
        aria-orientation="vertical"
        aria-labelledby="social-button"
        tabindex="-1"
      >
        <div class="" role="none">
          <a
            v-for="(item, k) in social"
            :key="k"
            class="block w-full px-4 py-3 text-left hover:bg-gray-lightest"
            role="menuitem"
            :href="socialUrl(item.url)"
            rel="nofollow"
            target="_blank"
            @click.prevent="share"
          >
            {{ item.name }}
          </a>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      open: false,
      social: [
        {
          name: 'Facebook',
          url: 'https://www.facebook.com/sharer/sharer.php?u=',
          icon: 'facebook',
        },
        {
          name: 'Twitter',
          url: 'https://twitter.com/intent/tweet?url=',
          icon: 'twitter',
        },
        {
          name: 'LinkedIn',
          url: 'https://www.linkedin.com/shareArticle?mini=true&url=',
          icon: 'linkedin',
        },
        {
          name: 'WhatsApp',
          url: 'https://wa.me/?text=',
          icon: 'whatsapp',
        },
      ],
    }
  },
  mounted() {
    document.addEventListener('click', this.closeDropdown)
  },
  beforeDestroy() {
    document.removeEventListener('click', this.closeDropdown)
  },
  methods: {
    // click outside to close dropdown
    closeDropdown(e) {
      if (!this.$el.contains(e.target)) {
        this.open = false
      }
    },
    toggleDropdown() {
      this.open = !this.open
    },
    socialUrl(url) {
      return `${url}${this.$config.baseURL}${this.$route.fullPath}`
    },
    share({ target }) {
      this.toggleDropdown()
      window.open(target.href, target.target, 'width=600,height=400')
    },
  },
}
</script>
